module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: _vm._isColmo + 'minibar',
    staticClass: " weex-ct weex-div",
    class: ['minibar-wrapper', _vm.hasBottomBorder && 'bottom-border', _vm.isFixed && 'isFixed'],
    style: ({
      'background-color': _vm.backgroundColor_
    }),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "dof-minibar weex-ct weex-div",
    style: (_vm._px2rem(_vm.newBarStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "left weex-ct weex-div",
    attrs: {
      "aria-label": _vm.leftButtonBlindHelp,
      "accessible": true,
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.leftButtonClicked($event)
      }
    }
  }, [_vm._t("left", [(_vm.leftButton_ && !_vm.leftText) ? _c('figure', {
    staticClass: "left-button weex-el weex-image",
    attrs: {
      "src": _vm.leftButton_,
      "data-img-src": _vm.leftButton_,
      "weex-type": "image"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.leftButton_ && !_vm.leftText && _vm._isColmo) ? _c('dof-iconfont', {
    staticStyle: {
      "width": "0.77333rem"
    },
    attrs: {
      "code": '\u4717',
      "size": 64,
      "color": 'rgba(255,255,255,0.80)',
      "data-evt-dofIconFontClicked": ""
    },
    on: {
      "dofIconFontClicked": _vm.leftButtonClicked
    }
  }) : _vm._e(), _vm._v(" "), (_vm.leftText) ? _c('p', {
    staticClass: "icon-text weex-el weex-text",
    style: (_vm._processExclusiveStyle(_vm.newTextStyle, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.leftText))]) : _vm._e()], {})], 2), _vm._v(" "), _vm._t("middle", [_c('div', {
    staticClass: "middle-title-wrapper weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: "middle-title weex-el weex-text",
    style: (_vm._processExclusiveStyle(_vm.newTextWrapStyle, 75, 'text')),
    attrs: {
      "aria-label": _vm.title ? _vm.title + '。文本。' : '',
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.subTitle) ? _c('p', {
    staticClass: "middle-sub-title weex-el weex-text",
    style: (_vm._processExclusiveStyle(_vm.newTextWrapStyleSubTitle, 75, 'text')),
    attrs: {
      "aria-label": _vm.subTitle ? _vm.subTitle + '。文本。' : '',
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.subTitle))]) : _vm._e()])], {}), _vm._v(" "), _c('div', {
    staticClass: "right weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.rightButtonClicked($event)
      }
    }
  }, [_vm._t("right", [(_vm.rightButton_ && _vm.rightButton_ !== 'default' && !_vm.rightText) ? _c('figure', {
    staticClass: "right-button weex-el weex-image",
    attrs: {
      "src": _vm.rightButton_,
      "aria-hidden": true,
      "data-img-src": _vm.rightButton_,
      "weex-type": "image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.rightButton_ === 'default' && _vm._isColmo && !_vm.rightText) ? _c('dof-iconfont', {
    staticClass: "right-button",
    attrs: {
      "code": '\u4807',
      "size": 64,
      "data-evt-dofIconFontClicked": ""
    },
    on: {
      "dofIconFontClicked": _vm.rightButtonClicked
    }
  }) : _vm._e(), _vm._v(" "), (_vm.rightText) ? _c('p', {
    staticClass: "icon-text weex-el weex-text",
    style: (_vm._processExclusiveStyle(_vm.newTextStyle, 75, 'text')),
    attrs: {
      "aria-label": _vm.rightText ? _vm.rightText + '。按钮。' : '',
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.rightText))]) : _vm._e()], {})], 2)], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f607d5d2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f607d5d2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-minibar/index.vue
// module id = 680
// module chunks = 0 1